export default __webpack_public_path__ + "static/media/ic_fullscreen02.9dfa5329.svg";